module.exports = __webpack_public_path__ + "6c9f2c0025a96e469b4b73f334e40c34.svg";